export const ROUTE_PATHS = {
  HOME: '/',
  FIXTURE: ':fixtureId',
  OKTA_LOGIN_CALLBACK: '/auth/okta',
  SUPER_ADMIN: '/super-admin',
};
